interface IConfig {
    gatewayUrl: string
}

export default ((window as any).__env__ as IConfig)

export const loginUrlPart = '/login';
export const sessionTimeoutParam = 'session-timeout';